import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/menu_bar.svg'
import _imports_1 from '@/assets/img/menu_close.svg'
import _imports_2 from '@/assets/img/menu_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-62439a17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "num" }, [
  /*#__PURE__*/_createTextVNode("第 "),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode(" 部")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-en" }, "LEARN"),
  /*#__PURE__*/_createElementVNode("p", { class: "title-ja" }, "遠隔平和学習の模様")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "num" }, [
  /*#__PURE__*/_createTextVNode("第 "),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode(" 部")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-en" }, "VR ART"),
  /*#__PURE__*/_createElementVNode("p", { class: "title-ja" }, "高校生VRアート作品")
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "num" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-en" }, [
    /*#__PURE__*/_createTextVNode("SPECIAL"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("CONTENTS")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-ja" }, "せきぐちあいみスペシャルVR作品")
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FirstView = _resolveComponent("FirstView")!
  const _component_Intro = _resolveComponent("Intro")!
  const _component_Learn = _resolveComponent("Learn")!
  const _component_Scroll = _resolveComponent("Scroll")!
  const _component_VrArt = _resolveComponent("VrArt")!
  const _component_Presenter = _resolveComponent("Presenter")!
  const _component_About = _resolveComponent("About")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "bar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = true))
      }, _hoisted_3)
    ]),
    _createElementVNode("nav", {
      class: _normalizeClass({ open: _ctx.isOpen })
    }, [
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false))
      }, _hoisted_5),
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scroll('learn')))
        }, _hoisted_8),
        _createElementVNode("li", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scroll('vrart')))
        }, _hoisted_11),
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scroll('special')))
        }, _hoisted_14)
      ]),
      _hoisted_15
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpen = false)),
          class: "overlay"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_FirstView),
    _createVNode(_component_Intro, { onScroll: _ctx.scroll }, null, 8, ["onScroll"]),
    _createVNode(_component_Learn),
    _createVNode(_component_Scroll),
    _createVNode(_component_VrArt),
    _createVNode(_component_Presenter),
    _createVNode(_component_About)
  ], 64))
}